import React from "react";
import {
  ShowView,
  ShowController,
  Tab,
  TabbedShowLayout,
  SimpleShowLayout,
  TextField
} from "react-admin";
import BaseballTab from "./BaseballTab";

const GamePlayerShow = (props) => {
  return (
    <ShowController {...props}>
      {(controllerProps) => (
        <ShowView {...props} {...controllerProps}>
          <TabbedShowLayout>
            <Tab label="summary">
              <SimpleShowLayout>
                <TextField source="id" />
                <TextField source="sportCode" />
              </SimpleShowLayout>
            </Tab>
            {controllerProps.record &&
              controllerProps.record.sportCode === "football" && (
                <Tab label="football">
                  <SimpleShowLayout>
                    <TextField source="football.id" />
                    <TextField source="football.puntingYards" />

                    <TextField source="football.passingCompletions" />
                    <TextField source="football.passingCompletionPercentage" />
                    <TextField source="football.passingAttempts" />
                    <TextField source="football.passingInterceptions" />
                    <TextField source="football.passingYards" />
                    <TextField source="football.passingAverage" />
                    <TextField source="football.passingTouchdowns" />

                    <TextField source="football.rushingAttempts" />
                    <TextField source="football.rushingYards" />
                    <TextField source="football.rushingAverage" />
                    <TextField source="football.rushingTouchdowns" />
                    <TextField source="football.receptions" />
                    <TextField source="football.receivingYards" />
                    <TextField source="football.receivingAverage" />
                    <TextField source="football.receivingTouchdowns" />

                    <TextField source="football.fieldGoalAttempts" />
                    <TextField source="football.fieldGoalsMade" />
                    <TextField source="football.fieldGoalYards" />

                    <TextField source="football.totalPoints" />
                  </SimpleShowLayout>
                </Tab>
              )}
            {controllerProps.record &&
              controllerProps.record.sportCode === "girls-volleyball" && (
                <Tab label="volleyball">
                  <SimpleShowLayout>
                    <TextField source="girlsvolleyball.id" />
                    <TextField source="girlsvolleyball.kills" />
                    <TextField source="girlsvolleyball.blocks" />
                    <TextField source="girlsvolleyball.aces" />
                    <TextField source="girlsvolleyball.digs" />
                    <TextField source="girlsvolleyball.assists" />
                  </SimpleShowLayout>
                </Tab>
              )}
            {controllerProps.record &&
              controllerProps.record.sportCode === "softball" && (
                <Tab label="softball">
                  <BaseballTab />
                </Tab>
              )}
            {controllerProps.record &&
              controllerProps.record.sportCode === "baseball" && (
                <Tab label="baseball">
                  <BaseballTab />
                </Tab>
              )}
          </TabbedShowLayout>
        </ShowView>
      )}
    </ShowController>
  );
};

export default GamePlayerShow;
